import { Routes, Route, Navigate, Link } from 'react-router-dom'
import { useState, useEffect } from 'react'

import Footer from './components/Footer/Footer'
import Home from './components/Home/Home'
import Eix from './components/Eixos/Eixos'
import Responsable from './components/Responsable/Responsable'

import PlaEstrategic from '../src/assets/img/plaEstrategic2.png'

import styles from './App.module.css'

const App = () => {

    const [ data, setData ] = useState(null)

    useEffect(() => {
        const url = process.env.REACT_APP_API_URL
        fetch(url)
        .then((response) => {
            return response.json()
        })
        .then(datas => {
            const dataJson = JSON.parse(datas)
            console.log("Data JSON", dataJson)
            setData(dataJson.processos['34'])
        })
    },[])

    return (
        <div className={styles.container}>
            <header>
                <div className={styles.pla}>
                    <Link to={'/home'}><img src={PlaEstrategic} alt='Pla'/></Link>
                </div>
            </header>
            <main>
                <Routes>
                    <Route path="/" element={<Navigate to='/home'></Navigate>}></Route>
                    <Route path="/home" element={<Home data={data}></Home>}/>
                    <Route path="/eixos/">
                        <Route path="eix1" element={<Eix data={data} number={0}></Eix>}/>
                        <Route path="eix2" element={<Eix data={data} number={1}></Eix>}/>
                        <Route path="eix3" element={<Eix data={data} number={2}></Eix>}/>
                        <Route path="eix4" element={<Eix data={data} number={3}></Eix>}/>
                    </Route>
                    <Route path='/responsable' element={<Responsable data={data}></Responsable>}></Route>
                </Routes>
            </main>
            <footer>
                <Footer></Footer>
            </footer>
        </div>
    )
}

export default App